export default __webpack_public_path__ + "images/LVOT_dark.052382ee8451c51403ee6f955def85eb.png";